import { call, put, select, takeLatest, fork, all } from 'redux-saga/effects';
import axios from 'axios';
import { SagaIterator } from 'redux-saga';

import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { idTokenSelector } from 'services/auth/selectors';
import { ERROR_MODAL_QUERY_STRING_PARAM } from 'components/ErrorModal/constants';
import { setSubmitHasFailed } from 'services/virtualizedTable/actions';

import {
    RequestedCreateProductAction,
    RequestedUpdateProductAction,
    RequestedDeleteProductAction
} from './types';
import {
    productCreated,
    failedCreateProduct,
    succeededUpdateProduct,
    failedUpdateProduct,
    succeededDeleteProduct,
    failedDeleteProduct,
    setProduct
} from './actions';
import {
    PRODUCT_CREATE_REQUESTED,
    PRODUCT_UPDATE_REQUESTED,
    PRODUCT_DELETE_REQUESTED
} from './constants';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* postProduct(
    action: RequestedCreateProductAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const url = `${REACT_APP_API_URL}/v1/SprayProducts`;

    try {
        const response = yield call(axios, url, {
            method: 'post',
            headers: {
                Authorization: idToken
            },
            data: action.data
        });
        yield put(productCreated(response));
        yield put(setProduct(response.data));
    } catch (error) {
        yield put(failedCreateProduct(error));
        yield put(setSubmitHasFailed(true));
        yield put(
            updateQueryString({
                [ERROR_MODAL_QUERY_STRING_PARAM]: 'PRODUCT_CREATE'
            })
        );
    }
}

export function* watchCreateProduct(): SagaIterator {
    yield takeLatest(PRODUCT_CREATE_REQUESTED, postProduct);
}

export function* patchProduct(
    action: RequestedUpdateProductAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);

    const {
        payload: { productId, product }
    } = action;

    try {
        const url = `${REACT_APP_API_URL}/v1/SprayProducts/${productId}`;

        const response = yield call(axios, url, {
            method: 'patch',
            headers: {
                Authorization: idToken
            },
            data: product
        });
        yield put(succeededUpdateProduct(response));
        yield put(setProduct(response.data));
    } catch (error) {
        yield put(failedUpdateProduct(error));
        yield put(setSubmitHasFailed(true));
        yield put(
            updateQueryString({
                [ERROR_MODAL_QUERY_STRING_PARAM]: 'PRODUCT_UPDATE'
            })
        );
    }
}

export function* watchProductUpdateRequested(): SagaIterator {
    yield takeLatest(PRODUCT_UPDATE_REQUESTED, patchProduct);
}

export function* deleteProduct(
    action: RequestedDeleteProductAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const { productId } = action.payload;

    try {
        const url = `${REACT_APP_API_URL}/v1/SprayProducts/${productId}`;
        const response = yield call(axios, url, {
            method: 'delete',
            headers: {
                Authorization: idToken
            }
        });
        const res = yield call(axios, url, {
            method: 'get',
            headers: {
                Authorization: idToken
            }
        });
        yield all([
            put(succeededDeleteProduct(response)),
            put(setProduct(res.data))
        ]);
    } catch (error) {
        yield all([
            put(failedDeleteProduct(error)),
            put(setSubmitHasFailed(true)),
            put(
                updateQueryString({
                    [ERROR_MODAL_QUERY_STRING_PARAM]: 'PRODUCT_DELETE'
                })
            )
        ]);
    }
}

export function* watchProductDeleteRequested(): SagaIterator {
    yield takeLatest(PRODUCT_DELETE_REQUESTED, deleteProduct);
}

export default function* productsSagas(): SagaIterator {
    yield all([
        fork(watchCreateProduct),
        fork(watchProductUpdateRequested),
        fork(watchProductDeleteRequested)
    ]);
}
